import React from 'react';
import { Title, Text as Paragraph } from '../Typography';

interface ISimpleList {
  title: string;
  data?: {
    title: string;
    list?: string[];
    additionalText?: string;
  }[];
}

export const SimpleList = ({ title, data, ...props }: ISimpleList) => {
  if (!data?.length) {
    return null;
  }

  return (
    <div {...props}>
      <Title className="mb-6 md:mb-10" tag="div" type="md">
        {title}
      </Title>
      {data?.map((item, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={`simple-list-${index}`}>
          <div className="mb-6 md:my-3">
            {item?.list?.map((listItem, idx) => (
              <Paragraph
                className="relative text-black pl-12"
                tag="div"
                type="md"
                key={`simple-list-item-${idx}`}
              >
                <div className="absolute h-0.5 w-6.5 left-0 top-3 bg-light-brown" />
                <div dangerouslySetInnerHTML={{ __html: listItem }} />
              </Paragraph>
            ))}
            {item.additionalText && (
              <Paragraph className="relative text-black pl-12" tag="div" type="md">
                ({item.additionalText})
              </Paragraph>
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};
